<template>
<div class="container-responsive">
  <loading v-bind:active.sync="loading"></loading>
  <div class="row full-wrapper">
    <image-modal ref="imageModal" v-bind:selectedImage="selectedImage" v-bind:photos="photos.large"></image-modal>
    <auth-modal ref="authModal"></auth-modal>
    <div class="col-xl-2 order-2 order-xl-1">
      <!-- TODO: Fix <fact-sheet v-bind:originRoute="previousRoute" v-bind:searchString="searchString" v-bind:house="house"></fact-sheet> -->
    </div>
    <div class="col-xl-7 order-3 order-xl-2">
      <div class="row bottom-padding">
        <div class="picture" v-bind:style="coverPhotoStyle"></div>
        <div class="house-information-overlay" v-on:click="showImageModal(0)">
          <table class="table table-borderless">
            <tbody>
              <tr><td class="address-part-one">{{ addressPartOne }}</td></tr>
              <tr><td class="address-part-two">{{ addressPartTwo }}</td></tr>
              <tr>
                <td class="d-inline-block"><h4 v-if="bedroomCount">{{bedroomCount}} <i class="fas fa-bed"></i></h4></td>
                <td class="d-inline-block"><h4 v-if="bathroomCount">{{bathroomCount}} <i class="fas fa-bath"></i></h4></td>
                <td class="d-inline-block"><h4 v-if="houseSqft">{{houseSqft}} ft<sup>2</sup> <i class="fas fa-ruler-combined"></i></h4></td>
              </tr>
              <tr><td class="house-status">{{ status }}</td></tr>
            </tbody>
          </table>
        </div>
      </div>
      <hr>
      <home-profile-tabs v-bind:uniqueId="uniqueId" v-bind:state="state" v-bind:publicProfile="false" v-bind:userEntered="userEntered"></home-profile-tabs>
      <summer-maintenance></summer-maintenance>
      <hr class="no-margin">
      <div role="tablist">
        <div href="#" v-b-toggle.accordion-8 class="accordion-title">
          <h5 class="d-inline">My HomFAX Receipts</h5>
          <i v-if="!homfaxReceiptsCollapse" class="fas fa-arrow-down float-right"></i>
          <i v-if="homfaxReceiptsCollapse" class="fas fa-arrow-up float-right"></i>
        </div>
        <b-collapse id="accordion-8" v-if="homfaxRecords" role="tabpanel" v-model="homfaxReceiptsCollapse">
          <homfax-receipts v-bind:homfaxRecords="homfaxRecords" v-bind:moreRecordsToLoad="moreHomfaxRecordsToLoad" v-on:showHomfaxModal="showHomfaxModal" v-on:newHomfaxReceipt="getHomFAX" v-on:loadMoreHomfaxRecords="getHomFAX"></homfax-receipts>
        </b-collapse>
        <hr class="no-margin">
        <div v-if="homfaxRecords" href="#" v-b-toggle.accordion-9 class="accordion-title">
          <h5 class="d-inline">My HomFAX Paid Services</h5>
          <i v-if="!homfaxPaidServicesCollapse" class="fas fa-arrow-down float-right"></i>
          <i v-if="homfaxPaidServicesCollapse" class="fas fa-arrow-up float-right"></i>
        </div>
        <b-collapse id="accordion-9" v-if="homfaxRecords" role="tabpanel" v-model="homfaxPaidServicesCollapse">
          <homfax-statistics v-bind:uniqueId="uniqueId" v-on:showHomfaxModal="showHomfaxModal"></homfax-statistics>
        </b-collapse>
        <hr class="no-margin">
        <div v-if="homfaxRecords" href="#" v-b-toggle.accordion-10 class="accordion-title">
          <h5 class="d-inline">My HomFAX DIY</h5>
          <i v-if="!homfaxDiySavingsCollapse" class="fas fa-arrow-down float-right"></i>
          <i v-if="homfaxDiySavingsCollapse" class="fas fa-arrow-up float-right"></i>
        </div>
        <b-collapse id="accordion-10" v-if="homfaxRecords" role="tabpanel" v-model="homfaxDiySavingsCollapse">
          <homfax-statistics v-bind:uniqueId="uniqueId" v-bind:diyFilter="true" v-on:showHomfaxModal="showHomfaxModal"></homfax-statistics>
        </b-collapse>
        <hr class="no-margin">
        <div href="#" v-b-toggle.accordion-11 class="accordion-title">
          <h5 class="d-inline">My HomFAX Appliances</h5>
          <i v-if="!homfaxAppliancesCollapse" class="fas fa-arrow-down float-right"></i>
          <i v-if="homfaxAppliancesCollapse" class="fas fa-arrow-up float-right"></i>
        </div>
        <b-collapse id="accordion-11" v-if="homfaxRecords" role="tabpanel" v-model="homfaxAppliancesCollapse">
          <appliances v-bind:appliances="detailedAppliances" v-bind:propertyId="uniqueId" v-bind:rooms="rooms" v-bind:applianceOptions="applianceOptions"></appliances>
        </b-collapse>
        <hr class="no-margin">
        <div href="#" v-b-toggle.accordion-1 class="accordion-title">
          <h5 class="d-inline"><i v-if="propertyCollapse" class="fas fa-home"></i>Property Details</h5>
          <i v-if="!propertyCollapse" class="fas fa-arrow-down float-right"></i>
          <i v-if="propertyCollapse" class="fas fa-arrow-up float-right"></i>
        </div>
        <b-collapse id="accordion-1" role="tabpanel" v-model="propertyCollapse">
          <user-property-details></user-property-details>
        </b-collapse>
        <span v-if="!offMarket">
          <hr class="no-margin">
          <div href="#" v-b-toggle.accordion-2 class="accordion-title">
            <h5 class="d-inline">Open Houses</h5>
            <i v-if="!openHousesCollapse" class="fas fa-arrow-down float-right"></i>
            <i v-if="openHousesCollapse" class="fas fa-arrow-up float-right"></i>
          </div>
          <b-collapse id="accordion-2" role="tabpanel" v-model="openHousesCollapse">
            <open-houses v-bind:openHouses="openHouses"></open-houses>
          </b-collapse>
        </span>
        <hr class="no-margin">
        <div v-if="taxHistory" href="#" v-b-toggle.accordion-3 class="accordion-title">
          <h5 class="d-inline">Tax History</h5>
          <i v-if="!taxHistoryCollapse" class="fas fa-arrow-down float-right"></i>
          <i v-if="taxHistoryCollapse" class="fas fa-arrow-up float-right"></i>
        </div>
        <b-collapse id="accordion-3" v-if="taxHistory" role="tabpanel" v-model="taxHistoryCollapse">
          <tax-history v-bind:taxHistory="taxHistory"></tax-history>
        </b-collapse>
        <hr class="no-margin">
        <div v-if="priceHistory" href="#" v-b-toggle.accordion-4 class="accordion-title">
          <h5 class="d-inline">Property History</h5>
          <i v-if="!propertyHistoryCollapse" class="fas fa-arrow-down float-right"></i>
          <i v-if="propertyHistoryCollapse" class="fas fa-arrow-up float-right"></i>
        </div>
        <b-collapse id="accordion-4" v-if="priceHistory" role="tabpanel" v-model="propertyHistoryCollapse">
          <property-history v-bind:propertyHistory="priceHistory"></property-history>
        </b-collapse>
        <hr class="no-margin">
        <div href="#" v-b-toggle.accordion-7 class="accordion-title">
          <h5 class="d-inline">Disclosures</h5>
          <i v-if="!disclosureCollapse" class="fas fa-arrow-down float-right"></i>
          <i v-if="disclosureCollapse" class="fas fa-arrow-up float-right"></i>
        </div>
        <b-collapse id="accordion-7" role="tabpanel" v-model="disclosureCollapse">
          <disclosures></disclosures>
        </b-collapse>
        <hr class="no-margin">
      </div>
    </div>
    <div class="col-xl-7 order-3 order-xl-2" v-if="endPath === 'images'">
      <div class="card-columns">
        <div class="card" v-for="(image, index) in photos.medium" v-bind:key="index">
          <img class="card-img-top" v-bind:src="image" alt="Card image cap" v-on:click="showImageModal(index)">
        </div>
      </div>
    </div>
    <div class="col-xl-3 order-1 order-xl-3">
      <h2 class="homfax-title">Welcome Back!</h2>
      <p>HomApt HomFAX allows you to keep track of all maintenance and remodeling you do to your home.<br/>
         Why?<br/>
         ~ Track Home Value<br/>
         ~ Taxes<br/>
         ~ Seasonal Tips for Homeownership<br/>
         ~ Selling Maintenance Portfolio<br/>
         ~ Coupons from Vendors<br/>
         ~ Maintenance Reminders<br/>
         ~ DYI To Dos<br/>
      </p>
      <button class="btn btn-primary" v-on:click="showHomfaxModal">Add HomFAX</button>
      <homfax-modal ref="homfaxModal" v-bind:propertyId="uniqueId" v-bind:homfax="selectedHomfax" v-on:newHomfaxReceipt="getHomFAX" v-on:resetSelectedHomfax="resetSelectedHomfax"></homfax-modal>
      <hr>
      <h3>Thinking about Selling?</h3>
      <p>HomApt Realty will save you money with our 1.5% Listing Fee</p>
      <router-link to="/contact">
        <button class="btn btn-primary">Contact Agent</button>
      </router-link>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import router from '../../../router/index.js'
import VDaySelector from 'vuelendar/components/vl-day-selector'
import schools from './dropdowns/Schools.vue'
import neighborhood from './dropdowns/Neighborhood.vue'
import UserPropertyDetails from './dropdowns/UserPropertyDetails.vue'
import openHouses from './dropdowns/OpenHouses.vue'
import taxHistory from './dropdowns/TaxHistory.vue'
import propertyHistory from './dropdowns/PropertyHistory.vue'
import disclosures from './dropdowns/Disclosures.vue'
import factSheet from './leftSide/FactSheet.vue'
import terms from '../homeSearch/rightSide/Terms.vue'
import imageModal from './ImageModal.vue'
import AuthModal from '../../authentication/TheAuthModal.vue'
import SummerMaintenance from './seasonalPropertyTips/SummerMaintenanceRecommendations.vue'
import HomfaxReceipts from './dropdowns/HomFAXReceipts.vue'
import HomfaxStatistics from './dropdowns/HomFAXStatistics.vue'
import HomfaxModal from './rightSide/HomFAXModal.vue'
import Appliances from './dropdowns/Appliances.vue'
import HomeProfileTabs from './HomeProfileTabs.vue'

/* eslint-disable */
var houseSVG = ['<?xml version="1.0" encoding="utf-8"?>',
'<!-- Generator: Adobe Illustrator 23.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->',
'<svg version="1.1" id="Layer_1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"',
        'x="0px" y="0px" viewBox="0 0 288 417" style="enable-background:new 0 0 288 417;" xml:space="preserve">',
'<style type="text/css">',
        '.st0{fill:#748096;}',
        '.st1{fill:#363E4A;}',
        '.st2{fill:#FCD990;}',
'</style>',
'<path class="st0" d="M105.5,277v112.4l26.5,23.7c5.7,5.1,18.3,5.1,24.1,0l26.5-23.7V277c-12.5,1.4-25.4,2.2-38.5,2.2',
        'S118,278.4,105.5,277z"/>',
'<circle class="st1" cx="144" cy="144" r="144"/>',
'<path class="st2" d="M140.8,89.9l-77.5,63.8v68.9c0,3.7,3,6.7,6.7,6.7l47.1-0.1c3.7,0,6.7-3,6.7-6.7v-40.2c0-3.7,3-6.7,6.7-6.7h26.9',
        'c3.7,0,6.7,3,6.7,6.7v40.2c0,3.7,3,6.7,6.7,6.7c0,0,0,0,0,0l47.1,0.1c3.7,0,6.7-3,6.7-6.7v-68.9l-77.4-63.7',
        'C145.3,88.4,142.7,88.4,140.8,89.9L140.8,89.9z M263.1,133.3L228,104.3V46.1c0-2.8-2.3-5-5-5h-23.5c-2.8,0-5,2.3-5,5v30.5',
        'l-37.6-30.9c-7.4-6.1-18.2-6.1-25.6,0L24.8,133.3c-2.1,1.8-2.4,5-0.7,7.1c0,0,0,0,0,0l10.7,13c1.8,2.2,4.9,2.5,7.1,0.7c0,0,0,0,0,0',
        'l98.8-81.4c1.9-1.5,4.6-1.5,6.4,0l98.8,81.4c2.1,1.8,5.3,1.5,7.1-0.7c0,0,0,0,0,0l10.7-13C265.6,138.2,265.3,135,263.1,133.3',
        'C263.2,133.3,263.1,133.3,263.1,133.3L263.1,133.3z"/>',
'</svg>'].join('\n')
/* eslint-enable */

export default {
  async mounted () {
    await this.init()
  },
  components: {
    Loading,
    VDaySelector,
    schools,
    neighborhood,
    UserPropertyDetails,
    taxHistory,
    openHouses,
    propertyHistory,
    disclosures,
    factSheet,
    terms,
    imageModal,
    AuthModal,
    SummerMaintenance,
    HomfaxReceipts,
    HomfaxStatistics,
    HomfaxModal,
    Appliances,
    HomeProfileTabs
  },
  data () {
    return {
      loading: false,
      moreHomfaxRecordsToLoad: false,
      homfaxLastEvaluatedKey: null,
      homfaxRecordLimitParameter: 50,
      homfaxModalClicked: true,
      selectedImage: 0,
      selectedHomfax: null,
      searchString: null,
      homfaxRecords: [],
      homfaxReceiptsCollapse: false,
      homfaxPaidServicesCollapse: false,
      homfaxDiySavingsCollapse: false,
      homfaxAppliancesCollapse: false,
      propertyCollapse: false,
      openHousesCollapse: false,
      taxHistoryCollapse: false,
      propertyHistoryCollapse: false,
      schoolsCollapse: false,
      neighborhoodCollapse: false,
      disclosureCollapse: false,
      currentHouse: null,
      previousRoute: null,
      defaultApplianceOptions: [
        'Air Conditioner',
        'Central Vacuum',
        'Cooktop',
        'Dishwasher',
        'Disposal',
        'Dryer',
        'Exhaust Fan/Hood',
        'Freezer',
        'Fuel Tank',
        'Furnace',
        'Furnace Humidifier',
        'Hot Tub',
        'Iron Filter',
        'Kegerator',
        'Microwave',
        'Oven',
        'Radon Mitigation System',
        'Range',
        'Refrigerator',
        'Security System',
        'Smart Doorbell',
        'Smart Thermostat',
        'Sound System',
        'Tankless Water Heater',
        'Television',
        'Thermostat',
        'Trash Compactor',
        'Washer',
        'Water Filtration System',
        'Water Heater',
        'Water Osmosis System',
        'Wine Fridge',
        'Water Softener',
        'Other'
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getIdProvider',
      'getSecretAccessKey'
    ]),
    ...mapGetters('property', [
      'getBathroomCount',
      'getBedroomCount',
      'getBedrooms',
      'getCity',
      'getCoverPhoto',
      'getDetailedAppliances',
      'getDiningRoom',
      'getFamilyRoom',
      'getHouseSqft',
      'getKitchen',
      'getLivingRoom',
      'getOpenHouses',
      'getOtherRooms',
      'getPhotos',
      'getPriceHistory',
      'getSoldDate',
      'getSpecialCircumstances',
      'getState',
      'getStatus',
      'getStreetName',
      'getStreetNumber',
      'getStreetSuffix',
      'getTaxHistory',
      'getUniqueId',
      'getUnitNumber',
      'getUserEntered',
      'getZipCode'
    ]),
    bathroomCount () {
      return this.getBathroomCount
    },
    bedroomCount () {
      return this.getBedroomCount
    },
    city () {
      return this.getCity
    },
    coverPhoto () {
      return this.getCoverPhoto
    },
    bedrooms () {
      return this.getBedrooms
    },
    detailedAppliances () {
      return this.getDetailedAppliances
    },
    diningRoom () {
      return this.getDiningRoom
    },
    familyRoom () {
      return this.getFamilyRoom
    },
    houseSqft () {
      return this.getHouseSqft
    },
    kitchen () {
      return this.getKitchen
    },
    livingRoom () {
      return this.getLivingRoom
    },
    openHouses () {
      return this.getOpenHouses
    },
    otherRooms () {
      return this.getOtherRooms
    },
    photos () {
      return this.getPhotos
    },
    priceHistory () {
      return this.getPriceHistory
    },
    specialCircumstances () {
      return this.getSpecialCircumstances
    },
    state () {
      return this.getState
    },
    status () {
      var status = this.getStatus
      // Return Sold if sold within 30 days
      if (status === 'Closed' && (new Date().getTime() - new Date(this.getSoldDate).getTime()) / (1000 * 60 * 60 * 24) <= 30) {
        return 'Sold'
      }
      if (status === 'Closed') {
        return 'Off Market'
      }
      return status
    },
    streetName () {
      return this.getStreetName
    },
    streetNumber () {
      return this.getStreetNumber
    },
    streetSuffix () {
      return this.getStreetSuffix
    },
    taxHistory () {
      return this.getTaxHistory
    },
    uniqueId () {
      return this.getUniqueId
    },
    unitNumber () {
      return this.getUnitNumber
    },
    userEntered () {
      return this.getUserEntered
    },
    zipCode () {
      return this.getZipCode
    },
    rooms () {
      var rooms = []
      rooms.push('Kitchen')
      rooms.push('Dining Room')
      rooms.push('Family Room')
      rooms.push('Living Room')
      rooms.push('Utility Room')
      rooms.push('Hallway')
      rooms.push('Outside')
      this.bedrooms.forEach(bedroomDescription => {
        rooms.push(bedroomDescription.split(':')[0])
      })
      this.otherRooms.forEach(roomDescription => {
        rooms.push(roomDescription.split(':')[0])
      })
      if (!rooms.includes('Laundry')) rooms.push('Laundry')
      // Add custom rooms
      if (this.detailedAppliances && this.detailedAppliances.length && this.detailedAppliances.some(detailedAppliance => detailedAppliance.room && !rooms.includes(detailedAppliance.room))) {
        let currentApplianceRooms = this.detailedAppliances.map(a => a.room)
        let difference = currentApplianceRooms.filter(x => !rooms.includes(x))
        rooms.push(...difference)
      }
      rooms.push('Other')
      return rooms
    },
    applianceOptions () {
      if (this.detailedAppliances && this.detailedAppliances.length && this.detailedAppliances.some(detailedAppliance => detailedAppliance.appliance && !this.defaultApplianceOptions.includes(detailedAppliance.appliance))) {
        var appliances = [...this.defaultApplianceOptions]
        appliances.pop() // Remove 'Other' to put it as last option
        let currentAppliances = this.detailedAppliances.map(a => a.appliance)
        let difference = currentAppliances.filter(x => !this.defaultApplianceOptions.includes(x))
        appliances.push(...difference)
        appliances.sort()
        appliances.push('Other')
        return appliances
      }
      return this.defaultApplianceOptions
    },
    addressPartOne () {
      let address1 = this.streetNumber + ' ' + this.streetName + ' ' + this.streetSuffix
      if (this.unitNumber) {
        address1 += ' Unit Number: #' + this.unitNumber
      }
      return address1
    },
    addressPartTwo () {
      return this.city + ', ' + this.state + ' ' + this.zipCode
    },
    houseStatus () {
      if (this.specialCircumstances === 'Rental') return 'R'
      if (this.specialCircumstances === 'Foreclosure') return 'F'
      if (this.specialCircumstances === 'Off Market') return 'O'
      if (this.specialCircumstances === 'New Construction') return 'N'
      return ''
    },
    coverPhotoStyle () {
      return 'background-image: url("' + this.coverPhoto + '")'
    },
    endPath () {
      return this.$route.params.endPath
    },
    offMarket () {
      if (this.specialCircumstances === 'Off Market') return true
      return false
    }
  },
  methods: {
    ...mapActions([
      'unauthenticatedLogin'
    ]),
    ...mapActions('property', [
      'getProperty'
    ]),
    ...mapMutations('property', [
      'clearData'
    ]),
    async getHomFAX (reset = false) {
      try {
        this.loading = true
        var client = this.$store.getters.getHomFaxApigClientFactory
        var body = {}
        var params = {'property_id': this.uniqueId}
        var pathTemplate = '/homfax/{property_id}'
        var method = 'GET'
        var additionalParams = {
          queryParams: {
            limit: this.homfaxRecordLimitParameter
          }
        }
        let paginate = (this.homfaxLastEvaluatedKey && !reset)
        if (paginate) additionalParams.queryParams['last_evaluated_key'] = JSON.stringify(this.homfaxLastEvaluatedKey)
        var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        if (result.status === 200) {
          this.homfaxRecords = (paginate ? this.homfaxRecords.concat(result.data.data) : this.homfaxRecords = result.data.data)
          this.homfaxLastEvaluatedKey = ('last_evaluated_key' in result.data ? result.data.last_evaluated_key : null)
          this.moreHomfaxRecordsToLoad = (result.data.data.length === this.homfaxRecordLimitParameter)
        } else {
          console.log('Could not retrieve HomFAX records.')
        }
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    },
    loginRequired () {
      this.$refs.authModal.$refs.authModal.show()
    },
    showHomfaxModal (homfax) {
      if (homfax && homfax.timestamp) this.selectedHomfax = homfax
      if (this.getIdProvider) {
        this.$refs.homfaxModal.$refs.homfaxModal.show()
      } else {
        this.$refs.authModal.$refs.authModal.show()
      }
    },
    showImageModal (index) {
      this.selectedImage = index
      this.$refs.imageModal.$refs.imageModal.show()
      this.$nextTick(() => window.dispatchEvent(new Event('resize')))
    },
    resetSelectedHomfax () {
      this.selectedHomfax = null
    },
    async init () {
      try {
        await this.getProperty(this.$route.params.id)
        await this.getHomFAX()
      } catch (error) {
        console.log(error)
      }
    },
    async changeURL () {
      if (!this.getSecretAccessKey) {
        await this.unauthenticatedLogin()
      }
      router.push('/property/' + this.$route.params.id).catch((error) => {
        if (error.name !== 'NavigationDuplicated') {
          console.log(error)
        }
      })
    }
  },
  watch: {
    getSecretAccessKey: async function (newValue, oldValue) {
      if (oldValue === null && newValue !== null) {
        await this.init()
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    this.clearData()
    next()
  }
}
</script>

<style scoped>
.address-part-one {
  font-size: 2rem;
  font-weight: bold;
}

.address-part-two {
  font-size: 1.5rem;
}

.bottom-padding {
  padding-bottom: 1rem;
}

.terms-row {
  padding-top: 3rem;
}

.fas {
  width: 30px;
}

#accordion-6 {
  margin-bottom: 2rem;
}

.accordion-title {
  padding-top: 1rem;
  padding-bottom: 1rem;
  cursor: pointer;
}

.content-wrapper {
  margin-bottom: 1rem;
}

.full-wrapper {
  padding-top: 1rem;
}

.no-bottom-margin {
  margin-bottom: 0;
}

.small-col {
  padding-right: 0px !important;
}

.picture {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  cursor: pointer;
  position: relative;
  min-height: 300px;
  width: 100%;
}

@media (max-width: 992px) {
  .picture {
    min-height: 500px;
  }
}

.input-group, .form-group {
  width: 100%;
}

.no-margin {
  margin: 0;
}

.container-responsive {
  margin-right: 1rem;
  margin-left: 1rem;
}

table {
  margin-bottom: 0;
}

.broker-logo {
  height: 20px !important;
}

td {
  padding-right: 0;
  padding-bottom: 0;
  padding-top: 0;
}

.fa-arrow-down, .fa-arrow-up {
  margin-right: 1rem;
}

.card, card-img-top {
  box-shadow: None !important;
}

.card-columns {
  column-count: 3;
}

@media (max-width: 2000px) {
  .card-columns {
    column-count: 2;
  }
}

@media (max-width: 1300px) {
  .card-columns {
    column-count: 1;
  }
}

.card-img-top {
  cursor: pointer;
}

.house-information-overlay {
  background-color: rgba(255, 255, 255, .7);
  min-height: 300px;
  position: absolute;
  width: 100%;
}

.no-space {
  padding: 0;
  margin: 0;
}

.save-button {
  padding-right: 0.5rem;
}

.share-button {
  padding-left: 0.5rem;
}

.homfax-title {
  text-indent: 1rem;
}

.house-status {
  font-size: 1.5rem;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/UserPropertyPage.vue